const isDynamicStep = (step) => step.hasOwnProperty("stepStatus");
const ctaLabelSelectorProps = (_, props) => props;
export {
  ctaLabelSelectorProps,
  isDynamicStep
};
//# sourceMappingURL=state.js.map
